import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { CommonEdgeRaisedInputProp } from "../../../../../Type/CommonComponant";

const CommonRaisedInput = ({ inputType, label, placeholder,inputClass,rows }:CommonEdgeRaisedInputProp) => {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>{label}</Label>
          <Input autoComplete="" className={`input-air-primary ${inputClass}`} type={inputType} placeholder={placeholder} rows={rows} />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default CommonRaisedInput;
